import { usePage } from '@inertiajs/vue3';
import { PageProps } from '@/app/types';
import { AuthGuardEnum } from '@/enums/AuthGuardEnum';
import { isNil } from 'lodash';

/** 로그인한 유저의 정보를 반환함. */
export function getUser() {
    return usePage<PageProps>().props.auth.user;
}

const championStyleCount = 5;
export function getUserCharacterIndex(studentId: number) {
    return (studentId % championStyleCount) + 1;
}

export function isTeacher() {
    return (
        usePage<PageProps>().props.auth.guard === AuthGuardEnum.TEACHER ||
        usePage<PageProps>().props.auth.guard === AuthGuardEnum.ADMIN
    );
}

export function isStudent() {
    return usePage<PageProps>().props.auth.guard === AuthGuardEnum.STUDENT;
}

export function isScreen() {
    return window.location.href.includes('screen');
}

/**
 * 아바타 코드를 숫자로 변환합니다.
 * @param codeString A~Z
 * @returns 숫자
 */
export function getAvatarNumberCode(codeString: string | null | undefined) {
    if (isNil(codeString)) {
        return 0;
    }

    const baseAsciiValue = 'A'.charCodeAt(0) - 1;
    return codeString.charCodeAt(0) - baseAsciiValue;
}
